<!--
create by melody on 2018/12/9
description:lap分页组件
-->
<template>
    <div class="block" style="margin:20px 0;" v-if="total!=0">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParam.pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
export default {
    props:['total', 'searchParam'],
    data() {
        return {

        }
    },
    methods: {
        handleCurrentChange(val) {
            this.searchParam.pageNum = val
            this.$emit('successMethod')
        },
        handleSizeChange(val) {
            this.searchParam.pageSize = val
            this.$emit('successMethod')
        },
    }
}
</script>
<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/common/LapPagination.vue